type ImageConsentListener = (isOpen: boolean) => void

const IMAGE_CONSENT_STORAGE_KEY = 'casaideas_pwa_image_consent_accepted'

const listeners = new Set<ImageConsentListener>()
let isOpen = false
let pendingOnAccept: (() => void) | null = null

const notify = (): void => {
    listeners.forEach((listener) => listener(isOpen))
}

export const hasAcceptedImageConsent = (): boolean => {
    if (typeof window === 'undefined') return false
    try {
        return window.localStorage.getItem(IMAGE_CONSENT_STORAGE_KEY) === '1'
    } catch {
        return false
    }
}

export const persistImageConsentAccepted = (): void => {
    if (typeof window === 'undefined') return
    try {
        window.localStorage.setItem(IMAGE_CONSENT_STORAGE_KEY, '1')
    } catch {
        // Si localStorage falla, el modal se pedirá de nuevo.
    }
}

export const subscribeImageConsentAlert = (
    listener: ImageConsentListener
): (() => void) => {
    listeners.add(listener)
    listener(isOpen)
    return () => {
        listeners.delete(listener)
    }
}

export const openImageConsentModal = (onAccept?: () => void): void => {
    pendingOnAccept = onAccept ?? null
    isOpen = true
    notify()
}

export const closeImageConsentModal = (): void => {
    pendingOnAccept = null
    isOpen = false
    notify()
}

/** Acepta el consentimiento, persiste y abre el picker nativo antes de cerrar el modal. */
export const acceptImageConsentModal = (): void => {
    const onAccept = pendingOnAccept
    pendingOnAccept = null
    persistImageConsentAccepted()
    // El callback corre en el gesto de Aceptar, con el modal todavía abierto.
    // En iOS abre el selector nativo. En Android abre cámara o galería.
    onAccept?.()
    // Cerrar en el mismo turno cancela el selector nativo en iOS y Android.
    window.setTimeout(() => {
        isOpen = false
        notify()
    }, 400)
}
